import { Outlet } from 'react-router-dom'
import { Navigate } from 'react-router'
import { routeMarkets } from 'routes/RouteMarkets/RouteMarkets'
import { routeDeposit } from 'routes/RouteDeposit'
import { routeBorrow } from 'routes/RouteBorrow'
import { routeBorrowSent } from 'routes/RouteBorrow/RouteBorrowSent'
import { routeDashboard } from 'routes/RouteDashboard'
import { routeDashboardDeposits } from 'routes/RouteDashboardDeposits'
import { routeDashboardLoans } from 'routes/RouteDashboardLoans'
import { routeDashboardCollateral } from 'routes/RouteDashboardCollateral'
import { routeDashboardOldLoans } from 'routes/RouteDashboardOldLoans'
import { routeRepayment } from 'routes/RouteRepayment'
import { routeCollateral } from 'routes/RouteCollateral'
import { routeWithdrawalDeposit } from 'routes/RouteWithdrawalDeposit'
import { routeProfile } from 'routes/RouteProfile'
import { routeTransactionList } from 'routes/RouteTransactionList'

import { AppLayout } from 'shared/ui/layout/AppLayout'
import { AppLayoutMinimal } from 'shared/ui/layout/AppLayoutMinimal'
import { RootProvidersChained } from 'modules/appRoot/RootProvidersChained'

import * as links from './links'
import type { RouteObjectWithMeta } from './types'

export const routes: RouteObjectWithMeta[] = [
  {
    path: links.app,
    index: true,
    element: <Navigate to={links.markets} />,
  },
  {
    element: (
      <RootProvidersChained>
        <Outlet />
      </RootProvidersChained>
    ),
    children: [
      {
        element: <AppLayoutMinimal />,
        children: [
          {
            path: links.profile(':addressOrName'),
            ...routeProfile,
          },
        ],
      },
      {
        element: <AppLayout />,
        children: [
          {
            path: links.markets,
            ...routeMarkets,
          },
          {
            path: links.deposit,
            ...routeDeposit,
          },
          {
            path: links.borrow,
            ...routeBorrow,
          },
          {
            path: links.borrowSent(':txHash', ':loanIdx'),
            ...routeBorrowSent,
          },
          {
            path: links.dashboard,
            ...routeDashboard,
            children: [
              {
                path: links.dashboardDeposits,
                ...routeDashboardDeposits,
              },
              {
                path: links.dashboardLoans,
                ...routeDashboardLoans,
              },
              {
                path: links.dashboardCollateral,
                ...routeDashboardCollateral,
              },
              {
                path: links.dashboardOldLoans,
                ...routeDashboardOldLoans,
              },
            ],
          },
          {
            path: links.repayment(':loanId'),
            ...routeRepayment,
          },
          {
            path: links.collateral,
            ...routeCollateral,
          },
          {
            path: links.withdrawalDeposit(':poolAddress'),
            ...routeWithdrawalDeposit,
          },
          {
            path: links.transactionList,
            ...routeTransactionList,
          },
        ],
      },
    ],
  },
]
